import { RpcObservableRequestContext } from '../rpc-observable-request';
import { RpcObservableResultContext } from '../rpc-observable-result';

/**
 * RPC update theme request name and version.
 */
export class RpcObservableUpdateThemeKey {
    public static command = 'UpdateThemeObservable';
    public static version = '0.1.0';
}

/**
 * RPC observable update theme data.
 */
export interface RpcObservableUpdateThemeRequest extends RpcObservableRequestContext {
    /**
     * New extension theme
     */
    newTheme: string;
}

export type RpcObservableUpdateThemeResult = RpcObservableResultContext;

export interface RpcObservableUpdateThemeError extends RpcObservableResultContext {
    error: Error;
}
